var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineVideoVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14 21.48V2.52a.749.749 0 1 1 1.5 0v18.96a.749.749 0 1 1-1.5 0zM16.14 21.48V2.52c0-.41.34-.75.75-.75s.75.34.75.75v18.96a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54 7.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.35c.41 0 .75.34.75.75s-.34.75-.75.75H2.54zM2.03 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.86c.41 0 .75.34.75.75s-.34.75-.75.75H2.03zM2.48 17.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.41c.41 0 .75.34.75.75s-.34.75-.75.75H2.48zM17.54 7.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.35c.41 0 .75.34.75.75s-.34.75-.75.75h-4.35zM17.03 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.86c.41 0 .75.34.75.75s-.34.75-.75.75h-4.86z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h11a.749.749 0 1 1 0 1.5h-11zM17.48 17.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.41c.41 0 .75.34.75.75s-.34.75-.75.75h-4.41z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoVertical);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-vertical.dba99782ddb36bfcfdc19aa457a8d1f1.svg";
export { ForwardRef as ReactComponent };